module.exports = __webpack_public_path__ + "static/media/mv.419af179.svg";